module.exports = __webpack_public_path__ + "img/upload-lateral2-exotics.c0f46e71.jpg";